import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=504b6602&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=504b6602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504b6602",
  null
  
)

/* custom blocks */
import block0 from "./ButtonGroup.vue?vue&type=custom&index=0&blockType=platform-tab&%3AtabData=tabData&%40tabChange=tabChange"
if (typeof block0 === 'function') block0(component)

export default component.exports